import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getHomeTestimonials } from '../../api/home-testemonials';

export default function useGetHomeTestimonials(options) {
  const result = useQuery('get-home-testimonials', () => getHomeTestimonials(), {
    staleTime: 120 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });

  const formattedResult = useMemo(
    () => ({
      ...result,
      data: result?.data?.data,
    }),
    [result],
  );

  return formattedResult;
}
